
import { method } from 'lodash';

export default {
  name: 'DisclosureDetail',
  fetchOnServer: false,
  name: 'DisclosuresDetail',
  data() {
    return {
      disclosure: null,
    }
  },

  async fetch() {
    try {
      const res = await this.$axios.get(`${this.$config.apiEfsahUrl}/detail`, {
        params: {
          id: this.$route.params.id,
          lang: this.$i18n.locale,
        },
      })

      this.disclosure = res.data.root[0]
    } catch (error) {
      // console.log(error)
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
  },
}
